var ECommerceEventType;
(function (ECommerceEventType) {
    ECommerceEventType["AddPaymentInfo"] = "add_payment_info";
    ECommerceEventType["AddShippingInfo"] = "add_shipping_info";
    ECommerceEventType["AddToWishList"] = "add_to_wishlist";
    ECommerceEventType["AddToCart"] = "add_to_cart";
    ECommerceEventType["BeginCheckout"] = "begin_checkout";
    ECommerceEventType["Purchase"] = "purchase";
    ECommerceEventType["Refund"] = "refund";
    ECommerceEventType["RemoveFromCart"] = "remove_from_cart";
    ECommerceEventType["SelectItem"] = "select_item";
    ECommerceEventType["SelectPromotion"] = "select_promotion";
    ECommerceEventType["ViewCart"] = "view_cart";
    ECommerceEventType["ViewItem"] = "view_item";
    ECommerceEventType["ViewItemList"] = "view_item_list";
    ECommerceEventType["ViewPromotion"] = "view_promotion";
})(ECommerceEventType || (ECommerceEventType = {}));
export default ECommerceEventType;
//# sourceMappingURL=analytics-ecommerce-event-type.js.map